export const ROUTES = {
    HOME: "/",
    TIMELINE: "/#timeline",
    PRIZES: "/#prize",
    WORKSHOP: "/#workshop",
    TERMS: "/#terms",

    CERTIFICATE: '/iit-certificate',

    PHILOSOPHY: "/iit-philosophy",

    GALLERY_PHOTOS: "/iit-documentation#photos",
    GALLERY_TESTIMONIALS: "/iit-documentation#testimonials",

    EVENT_COMPETITION: "/iit-program#competition",
    EVENT_PANELISTS: "/iit-program#panelists",

    SPONSOR: "/#sponsor",
    
    MEDIA_PARTNER: "/#media-partner",

    PARTNER_AEI: "https://edukasi.accelist.com/",

    BAZAAR: "/iit-bazaar",

    NEWS: "/iit-news",

    // REGISTER: "https://link.accelist.com/DaftarIITxGenesis2025",
    REGISTER: "https://link.accelist.com/RegisterIIT2026",
};

export const COMPETITION_ROUTES = {
    PYTHON: "/iit-program?program=Coding",
    // SCRATCH: "/iit-program?program=Coding",
    // DUEL: "/iit-program?program=Coding",
    SUMO_GAME: "/iit-program?program=SumoRobot",
    OBSTACLE: "/iit-program?program=ObstacleDriving",
    SYMPOSIUM: "/iit-program?program=Symposium",
    INNOVATIVE: "/iit-program?program=Innovative",
    SCRATCH2026: "/iit-program?program=ScratchCoding2026",
    COMPETITIVE_PROGRAMMING2026: "/iit-program?program=CompetitiveProgramming2026",
    INNOVATIVE_TECHNOLOGY2026: "/iit-program?program=InnovativeTechnology2026",
    ECOQUEST2026: "/iit-program?program=EcoQuest2026",
    // DESIGN_DASH: "/iit-program?program=Obstacle-Robot",
};

export const EVENT_ROUTES = {
    COMPETITION: ROUTES.EVENT_COMPETITION,
    PANELISTS: ROUTES.EVENT_PANELISTS,
};

export const GALLERY_ROUTES = {
    PHOTOS: ROUTES.GALLERY_PHOTOS,
    TESTIMONIALS: ROUTES.GALLERY_TESTIMONIALS,
};

export const PARTNERS = [
    {
        label: "Accelist Edukasi Indonesia",
        href: "https://edukasi.accelist.com/",
    },
    // {
    //     label: "Universitas Nasional",
    //     href: "https://www.unas.ac.id/",
    // },
];

export const WEBSITE_LINKS = [
    { label: "https://www.accelist.com", href: "https://www.accelist.com" },
    { label: "https://edukasi.accelist.com/", href: "https://edukasi.accelist.com/" },
];
